module.exports = __webpack_public_path__ + "json/market11-0.json?9ae9b47c67971c963b624d145327e4b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market11-0.json
// module id = 1254
// module chunks = 3